module.exports = __webpack_public_path__ + "img/Thanksgiving.24990b90.jpg";